
export default {
    namespaced: true,
    state() {
      return {
        selctedSymbol:"BTCUSDT"
      };
    },
    mutations: {
        selctedSymbol(state,payload){
            state.selctedSymbol = payload
            console.log(state.selctedSymbol);
            
        }
    },
    actions: {
    },
};
